if (!customElements.get('klaim-mystery-boxes')) {
  customElements.define('klaim-mystery-boxes', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.scene = this.querySelector('.kmb__scene');
      if (!this.scene) return;
      this.anchor = this.querySelector('.kmb__reveal') || this.scene;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal, passive: true };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => {
        if (this.visible && !document.hidden && !this.frame) this.frame = requestAnimationFrame(() => this.update());
      };
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.toggleAttribute('data-in-view', this.visible && !this.reduced.matches && this.dataset.motion !== 'false');
        if (this.visible) this.schedule();
        else {
          cancelAnimationFrame(this.frame);
          this.frame = 0;
        }
      }, { rootMargin: '80px 0px' });
      this.observer.observe(this);
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      document.addEventListener('visibilitychange', this.schedule, options);
      this.reduced.addEventListener('change', () => {
        this.toggleAttribute('data-in-view', this.visible && !this.reduced.matches && this.dataset.motion !== 'false');
        this.update();
      }, options);
      this.update();
    }
    update() {
      this.frame = 0;
      const still = this.reduced.matches || this.dataset.motion === 'false';
      // One layout read per scroll frame; every animated output is transform or opacity.
      const bounds = still ? null : this.anchor.getBoundingClientRect();
      // Anchor to the actual closed box, not the empty space above the scene.
      const center = still ? 0 : bounds.top + (this.anchor === this.scene ? 0 : bounds.height * .5);
      const progress = still ? 1 : Math.max(0, Math.min(1, (innerHeight * .82 - center) / (innerHeight * .3)));
      const ease = value => value * value * (3 - 2 * value);
      const stage = (start, end) => ease(Math.max(0, Math.min(1, (progress - start) / (end - start))));
      const values = {
        '--kmb-progress': ease(progress),
        '--kmb-open': stage(0, .58),
        '--kmb-q2': stage(.52, .9)
      };
      for (const [key, value] of Object.entries(values)) {
        const rounded = value.toFixed(4);
        if (this.scene.style.getPropertyValue(key) !== rounded) this.scene.style.setProperty(key, rounded);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
